module.exports = __webpack_public_path__ + "img/pet_pairing_mode.a3e08dec.png";